import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";

export default function Industries() {
  const { t } = useI18n();
  const items = [
    {
      title: t("industries_section.restaurants_title"),
      body: t("industries_section.restaurants_body"),
      color: "#E11D48",
      img: "/images/industry-restaurant.jpg",
      href: "/industries#restaurants",
      key: "restaurants",
    },
    {
      title: t("industries_section.retail_title"),
      body: t("industries_section.retail_body"),
      color: "#0284C7",
      img: "/images/industry-retail.jpg",
      href: "/industries#retail",
      key: "retail",
    },
  ];
  return (
    <section data-testid="industries-section" className="py-24 sm:py-32 bg-zinc-50">
      <div className="container-oj">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">{t("sections.industries_overline")}</div>
          </div>
          <div className="md:col-span-8">
            <h2 className="font-display text-balance text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-oj-ink">
              {t("sections.industries_title")}
            </h2>
            <p className="mt-5 max-w-2xl text-lg text-zinc-600 leading-relaxed">
              {t("sections.industries_sub")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((i) => (
            <Link
              key={i.title}
              to={i.href}
              data-testid={`industry-${i.key}`}
              className="group relative overflow-hidden rounded-2xl border border-zinc-200 h-[460px]"
            >
              <img src={i.img} alt={i.title} className="absolute inset-0 w-full h-full object-cover scale-105 group-hover:scale-100 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10 group-hover:from-black/70 transition-colors" />
              <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/90 bg-white/10 backdrop-blur px-2.5 py-1 rounded">industry</span>
                <ArrowUpRight className="size-5 text-white" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-7 text-white">
                <div className="h-1 w-12 rounded-full mb-4" style={{ background: i.color }} />
                <h3 className="font-display text-3xl sm:text-4xl font-black tracking-tighter">{i.title}</h3>
                <p className="mt-3 text-white/85 max-w-md">{i.body}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
